export default __webpack_public_path__ + "static/media/w-fashion.53024529.svg";